var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 3.318a1 1 0 0 1 .27.037L12 5.238V15.38l.008.112c.042.289.247.508.492.508.276 0 .5-.277.5-.62V5.278l6.726-1.915A1 1 0 0 1 21 4.325v13.52a1 1 0 0 1-.726.962l-7.411 2.115a1 1 0 0 1-.544.002l-7.588-2.12A1 1 0 0 1 4 17.841V4.318a1 1 0 0 1 1-1Z",
  fill: "currentColor"
}))));

export default SvgBook;